<div class="page-container container w-100">
  <app-utility-toolbar></app-utility-toolbar>
  <h1 class="header mb-0">Automated Reports</h1>
  <div class="subtitle"
    >Manage your automated reports below or create a new automated report</div
  >
  <div class="row">
    @if (!loading) {
      <div class="col-12">
        <div class="buttons">
          <h5>Existing Automated Reports</h5>
          <button
            mat-raised-button
            (click)="createNew($event)"
            class="my-2"
            color="primary"
            >Create New</button
          >
        </div>
        <kendo-grid
          [kendoGridBinding]="gridData"
          [height]="600"
          [pageSize]="10"
          [pageable]="true"
          [sortable]="true"
        >
          @for (col of columns; track $index) {
            @if (col.field === 'cadenceValue') {
              <kendo-grid-column
                [field]="col.field"
                [title]="col.title"
                [width]="col.width"
              >
                <ng-template
                  kendoGridHeaderTemplate
                  let-group
                  let-field="field"
                  let-value="value"
                >
                  Cadence
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                  @if (dataItem.cadenceType === 'Daily') {
                    Daily
                  } @else if (dataItem.cadenceType === 'Weekly') {
                    Weekly on {{ getWeekdayLabel(+dataItem.cadenceValue) }}
                  } @else if (dataItem.cadenceType === 'Monthly') {
                    Monthly on the
                    {{ getMonthlySuffix(+dataItem.cadenceValue) }}
                  }
                </ng-template>
              </kendo-grid-column>
            } @else {
              <kendo-grid-column
                [field]="col.field"
                [title]="col.title"
                [width]="col.width"
              >
              </kendo-grid-column>
            }
          }
          <kendo-grid-column title="Actions" width="150">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="auto-reports-actions">
                <button matIconButton (click)="editRecord(dataItem)"
                  ><mat-icon>edit</mat-icon></button
                >
                <button matIconButton (click)="deleteRecord(dataItem)"
                  ><mat-icon>delete</mat-icon></button
                >
              </div>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
    }
    <ngx-loading [show]="loading"></ngx-loading>
  </div>
</div>
